__turbopack_context__.v({
  "blurredNotificationImg": "V5FaXa_blurredNotificationImg",
  "buttonLink": "V5FaXa_buttonLink",
  "buttons": "V5FaXa_buttons",
  "container": "V5FaXa_container",
  "content": "V5FaXa_content",
  "img": "V5FaXa_img",
  "linkWithArrow": "V5FaXa_linkWithArrow",
  "subContainer": "V5FaXa_subContainer",
  "title": "V5FaXa_title",
});
